<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section
        :class="[
            'story__blok story__blok--column-text',
            {
                'bg-chsc-raw': blok?.background,
            },
        ]"
    >
        <UiContainer
            :max-width="blok?.container_width"
            :class="{ 'px-9': blok?.container_width == 'max-w-full' }"
        >
            <StoryblokRichText :doc="blok?.text" />
        </UiContainer>
    </section>
</template>
